export default __webpack_public_path__ + "maps-examples-user-location-annotation-thumbnail-960-3e04c92a20f8ff57e63d3ab9737dc102.webp";